import { z } from 'zod';
import { allUserRoleSchema } from '../data.types.js';
import { BaseResponseSchema, dateSchema, emailSchema, integerIdSchema, userTypeSchema, uuidSchema, } from './primitives.js';
// Response Schemas
export const RefreshTokenSchema = z.object({
    refreshToken: z.string().min(1),
});
export const TokenPairSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    expiresIn: z.number(),
    refreshExpiresIn: z.number()
});
export const RefreshAccessTokenResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        tokens: TokenPairSchema
    })
});
export const UnifiedLoginUserSchema = z.object({
    id: integerIdSchema,
    email: emailSchema,
    userType: userTypeSchema,
    role: allUserRoleSchema,
    tenantId: uuidSchema.nullable().optional(),
    tenantName: z.string().nullable().optional(),
    hasTemporaryPassword: z.boolean()
});
export const UnifiedLoginResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        user: UnifiedLoginUserSchema,
        tokens: TokenPairSchema
    })
});
export const UnifiedLoginErrorResponseSchema = BaseResponseSchema.extend({
    data: z.object({})
});
export const LoginUserResponseSchema = z.object({
    id: integerIdSchema,
    email: emailSchema,
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    role: allUserRoleSchema,
    isActive: z.boolean(),
    emailVerified: z.boolean(),
    hasTemporaryPassword: z.boolean(),
    createdAt: dateSchema,
    passwordChangedAt: dateSchema.optional()
});
export const TenantInfoSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    subdomain: z.string()
});
export const LoginResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        user: LoginUserResponseSchema,
        tokens: TokenPairSchema,
        tenant: TenantInfoSchema.optional()
    })
});
export const UserClaimsResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        claims: z.record(z.any()) // Flexible claims object
    })
});
// Me session schemas — see ./schemas/auth.schemas.ts
export const UserClaimsErrorResponseSchema = BaseResponseSchema.extend({
    data: z.object({})
});
export const ChangePasswordResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        userType: userTypeSchema,
    })
});
export const ChangePasswordErrorResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        errors: z.array(z.string()).optional(),
        error: z.string().optional()
    })
});
export const TestConnectionResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        timestamp: dateSchema
    })
});
export const TestConnectionErrorResponseSchema = BaseResponseSchema.extend({
    data: z.object({})
});
//# sourceMappingURL=tenant-auth-session.schemas.js.map